import * as React from "react";
import { RefObject } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CommunityImpactIcon from "../../../../components/Icons/CommunityImpact";

import theme from "../../../../components/styles/theme/theme";

type Props = {
  communityInvestedRef: RefObject<HTMLHeadingElement>;
};

export const CommunityImpactBox: React.FC<Props> = ({
  communityInvestedRef,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="community_impact">
      <div className="community_title">
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          {t("boxes.community_impact")}
          <CommunityImpactIcon
            color={theme.palette.secondary.main}
            height="15px"
            width="15px"
            style={{ width: "25px" }}
          />
        </Typography>
      </div>
      <div className="community_invested">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={communityInvestedRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {t("boxes.invested_in_community_programs")}
        </Typography>
      </div>
    </div>
  );
};
